<button class="card">
  <div class="card-icon">
    <i [ngClass]="icon()"></i>
  </div>
  <div class="card-title">{{ title() }}</div>
  <div class="card-nip">{{ description() }}</div>
</button>
